import API from "../../../../../services/api";

export const API_PLANTILLAS_EMAIL = {
  getPlantillasEmail: async () => {
    return await API.get("/plantillas-email").then((res) => res.data);
  },
  addPlantillaEmail: async (data) => {
    return await API.post("/plantillas-email", data).then((res) => res.data);
  },
  editPlantillaEmail: async (id, data) => {
    return await API.put(`/plantillas-email/${id}`, data).then((res) => res.data);
  }
}